import React from "react";
import styled from "styled-components";
import { useStateContext } from "../../global-context/useGlobalContext";
import { motion, AnimatePresence } from "framer-motion";

const AboutSection = () => {
  const { language } = useStateContext();

  return (
    <AboutWrapper>
      <h1>{language ? "Comme ça," : "So..."}</h1>

      <h1>{language ? "vous avez" : "I heard"}</h1>

      <h1>{language ? "besoin d'un" : "you need"}</h1>
      {language ? (
        <AnimatePresence>
          <motion.h1 className="hide">
            <motion.span
              animate={{
                opacity: [0, 1, 1, 0, 0, 0, 0, 0],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                times: [0, 0.01, 0.32, 0.33, 0.5, 0.6, 0.7, 1],
              }}
              className="textAnim"
            >
              site web?
            </motion.span>
            <motion.span
              animate={{
                opacity: [0, 0, 0, 1, 1, 0, 0, 0],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                times: [0, 0.1, 0.33, 0.34, 0.65, 0.66, 0.8, 1],
              }}
              className="textAnim"
            >
              logo?
            </motion.span>
            <motion.span
              animate={{
                opacity: [0, 0, 0, 0, 0, 1, 1, 0],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                times: [0, 0.25, 0.5, 0.6, 0.67, 0.68, 0.99, 1],
              }}
              className="textAnim"
            >
              flyer?
            </motion.span>
          </motion.h1>
        </AnimatePresence>
      ) : (
        <motion.h1 className="hide">
          a
          <motion.span
            animate={{
              opacity: [0, 1, 1, 0, 0, 0, 0, 0],
            }}
            transition={{
              duration: 5,
              repeat: Infinity,
              times: [0, 0.01, 0.32, 0.33, 0.5, 0.6, 0.7, 1],
            }}
            className="textAnim En"
          >
            {" "}
            website?
          </motion.span>
          <motion.span
            animate={{
              opacity: [0, 0, 0, 1, 1, 0, 0, 0],
            }}
            transition={{
              duration: 5,
              repeat: Infinity,
              times: [0, 0.1, 0.32, 0.33, 0.65, 0.66, 0.8, 1],
            }}
            className="textAnim En"
          >
            {" "}
            logo?
          </motion.span>
          <motion.span
            animate={{
              opacity: [0, 0, 0, 0, 0, 1, 1, 0],
            }}
            transition={{
              duration: 5,
              repeat: Infinity,
              times: [0, 0.25, 0.5, 0.6, 0.66, 0.67, 0.99, 1],
            }}
            className="textAnim En"
          >
            {" "}
            flyer?
          </motion.span>
        </motion.h1>
      )}
    </AboutWrapper>
  );
};

export default AboutSection;

const AboutWrapper = styled.div`
  flex: 1;
  width: 100vw;
  height: 100vh;
  padding: 22.5vh 10vw;
  display: flex;
  flex-direction: column;
  align-items: start;
  font-size: 2rem;
  color: white;
  h1 {
    font-weight: 400;
  }

  @media (max-width: 400px) {
    font-size: 1.5rem;
  }
  @media (max-width: 500px) {
    align-items: start;
  }

  .hide {
    position: relative;
    width: 20rem;
  }
  .textAnim {
    position: absolute;
    top: 0;
    left: 0;
  }
  .En {
    left: 2.2rem;
  }
  span {
  }
`;
